/* eslint-disable react/jsx-key */
import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { List, message, Switch, Tooltip } from 'antd-v5';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import { SettingsContent } from '../../../components/SettingsContent';
import { enableAppointment, getStoresAppointmentEnabled } from '../../../../../../services/appointments';
import StyledLink from '../../../../../../components/Layout/StyledLink';

export const EnableAppointment = props => {
  const {
    data: allStores,
    isFetching,
    refetch,
  } = useQuery(
    ['allStores', props.merchantId, props.userId],
    async () => {
      return getStoresAppointmentEnabled();
    },
    {
      refetchOnWindowFocus: false,
      initialData: [],
    },
  );

  return (
    <div style={{ paddingTop: '25px' }}>
      <SettingsContent
        title="Stores Accepting Appointments"
        description="Enable and disable appointments for respective stores"
      >
        <List
          className="w-100-P"
          size="small"
          dataSource={allStores}
          renderItem={item => <EnableAppointmentItem item={item} refetch={refetch} />}
          loading={isFetching}
        />
      </SettingsContent>
    </div>
  );
};

const EnableAppointmentItem = ({ item, refetch }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [appointmentsEnabled, setAppointmentsEnabled] = useState(item?.appointments_enabled);
  // Graceful fallback: treat undefined as true so existing behavior isn't broken before backend deploys
  const storeHasHours = item.has_store_hours !== false;

  const handleSuccess = useCallback(
    async data => {
      try {
        setConfirmLoading(true);
        setAppointmentsEnabled(data);
        await enableAppointment(item.id, data);
        message.success('Appointment enabled successfully');
      } catch (error) {
        message.error('Error updating appointment type');
      } finally {
        refetch();
        setConfirmLoading(false);
      }
    },
    [item.id],
  );

  return (
    <List.Item
      styles={{ actions: { margin: 0 } }}
      actions={[
        <Switch
          value={appointmentsEnabled}
          onChange={value => handleSuccess(value)}
          loading={confirmLoading}
          disabled={!storeHasHours && !appointmentsEnabled}
        />,
      ]}
      key={item.id}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <span>{item.name}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          {!storeHasHours && (
            <Tooltip title="Set up store hours to enable appointments">
              <div style={{ color: '#999', fontSize: '13px', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center' }}>
                <InfoCircleOutlined style={{ marginRight: '4px' }} />
                Set up store hours to enable appointments
              </div>
            </Tooltip>
          )}
          <StyledLink to={`/Stores/edit-store/${item.id}`} className="m-right-30">
            Store settings
          </StyledLink>
        </div>
      </div>
    </List.Item>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    stores: state.stores,
    merchantId: state.auth.merchantId,
    userId: state.auth.userId,
  };
};
export default connect(mapStateToProps, {})(EnableAppointment);
